import React from "react";
import assetify from "@quintype/framework/assetify";
import subscriptionImage from "../../../../assets/images/nl-images/subsccription banner-on-homepage.png";
import "./uday-foundation.m.css";

// eslint-disable-next-line max-len
const SUMMARY = `This winter season, contribute to Uday Foundation's blanket donation drive and get a 6-month Newslaundry subscription free, and also a well-deserved shoutout from our social media handles for your kindness.`;

export const UdayFoundationBanner = () => {
  return (
    <div styleName="row-container">
      <div styleName="container" className="full-width-with-padding">
        <div styleName="left-container">
          <img
            styleName="logo-wrapper"
            src={"https://i0.wp.com/www.udayfoundation.org/wp-content/uploads/2020/03/JPG-File.jpg?ssl=1"}
            width="60px"
            alt="uday logo"
          />
          <h1 styleName="text-container">
            <span styleName="text support">The Season of</span>
            <span styleName="text-wrapper">
              <span styleName="text">Spreading&nbsp;</span>
              <span styleName="text">Warmth</span>
            </span>
          </h1>
        </div>
        <div styleName="right-container">
          <h2 styleName="title"> Newslaundry &amp; Uday Foundation</h2>
          <div styleName="summary">{SUMMARY}</div>
          <div styleName="btn-img-wrapper">
            <div styleName="subcribe-bottom">
              <button
                styleName="nl-btn"
                style={{ backgroundColor: "#2da9fa", borderColor: "#2da9fa" }}
                href={`https://www.udayfoundation.org/donations-help-us/`}
              >
                Contribute here
              </button>
            </div>
            <img styleName="info-image" src={assetify(subscriptionImage)} alt="subscription image" />
          </div>
        </div>
      </div>
    </div>
  );
};
